<div class="row row-sm add-form">
    <form autocomplete="off" class="p-0" novalidate [formGroup]="teacherREAssignForm ">
        <div class="col-lg-12 col-md-12">
            <div class="card-body">
                <div class="bc d-flex align-items-center pl-3">
                    <img alt="Logo" src="../../assets/img/FacultyMaster.png" class="mh-40px pb-2">
                    <div class="ml-2">
                        <h3 class="main-content-label mb-1"><b>
                               Re-Provisional Assignment
                            </b></h3>
                        <p class="text-muted card-sub-title mb-0">
                             Re-Provisional Assignment
                        </p>
                    </div>
                </div>
                <hr>
                <div class="row clearfix">
                    <div class="col-sm-3">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Session</mat-label>
                            <mat-select #select232 placeholder="Session" class="colorblack" formControlName="SessionId"
                                required>
                                <mat-select-filter *ngIf="select232.focused" [placeholder]="'Filter'"
                                    [displayMember]="'SnName'" [array]="sessionList"
                                    (filteredReturn)="SessionFilterList =$event"></mat-select-filter>
                                <mat-option *ngFor="let item of SessionFilterList" [value]="item.SnNo">
                                    {{item.SnName}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-3">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Course</mat-label>
                            <mat-select #select122 placeholder="Course" formControlName="CoCode" required>
                                <mat-select-filter *ngIf="select122.focused" [placeholder]="'Filter'"
                                    [displayMember]="'CoName'" [array]="CourseList"
                                    (filteredReturn)="filteredListCourse =$event">
                                </mat-select-filter>
                                <mat-option *ngFor="let item of filteredListCourse" [value]="item.CoCode"
                                    (click)="getsubjects(item.CoCode)">
                                    {{item.CoCode}} - {{item.CoName}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-3">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Subject</mat-label>
                            <mat-select #select123 placeholder="CoCode" class="colorblack" formControlName="SubCode">
                                <mat-select-filter *ngIf="select123.focused" [placeholder]="'Filter'"
                                    [displayMember]="'EsName'" [array]="subjectList"
                                    (filteredReturn)="filteredsubjectList =$event">
                                </mat-select-filter>
                                <mat-option *ngFor="let item of filteredsubjectList"
                                (click)="getWaitingTeachersData()" [value]="item.EsId">
                                    {{item.EsName}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 row ">
                        <div class="col-sm-12 prpl">
                             <button id="Back" type="button" [mat-dialog-close]="true"
                                class="btn btn-primary btn-icon-text floatright mr-3 mt-1">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/turn-left.gif" style="margin-right: 7px;">
                                    {{'header.faculty-data.titleList.Back'
                                    | translate}}
                                </span>
                            </button>
                        </div>
                    </div>
                    <hr class="mt-1">
                    <div  class="table-responsive table-container">
                        <table appShortTable id="datatable" class="table table-bordered text-nowrap text-left">
                            <thead>
                                <tr>
                                    <th class="f600 text-center hidden" width="5%"> Teacher Id </th>
                                    <th class="f600 text-center hidden" width="5%"> Exam Id </th>
                                    <th class="f600 text-left" width="5%"> Examiner Name </th>
                                    <th class="f600 text-left" width="10%"> Home College </th>
                                    <th class="f600 text-left" width="10%"> Re-Provisional </th>
                                </tr>
                            </thead>
                            <tbody id="table_data" formArrayName="intExternalWaitingTeaArray">
                                <tr *ngFor="let subject of getControlsIntExternal(); let i = index "
                                    [formGroupName]="i">
                                    <td class="text-left hidden">{{ subject.get('TeacherId').value }}
                                    </td>
                                    <td class="text-left hidden">{{ subject.get('EmId').value }}
                                    </td>
                                    <td class="text-left">{{ subject.get('TeacherName').value }}
                                    </td>
                                    <td class="text-left">{{ subject.get('CollegeName').value }}
                                    </td>
                                    <td class="text-left">
                                        <i (click)="ReProvision(subject)" 
                                            class="fa fa-edit" style="cursor: pointer;"></i>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>